import PurchaseContainer from './PurchaseContainer';

export default PurchaseContainer;
